// Conversion helpers — turn the user's own data into upgrade motivation.
// The Coach already computes behavioral leaks in dollars; surfacing that number
// in the trial banner and upgrade prompts is the single strongest money-based
// hook we have ("you're leaking $X — Pro fixes it").
import { useMemo } from 'react';
import { useStore } from '../store';
import { diagnoseLeaks } from './coach';

/** Total $ the user is leaking to behavioral patterns, across all visible trades. */
export function useLeakValue(): number {
  const { getFilteredTrades, breakEvenRange, dailyMaxLoss, timezone } = useStore();
  const trades = getFilteredTrades();
  return useMemo(() => {
    const leaks = diagnoseLeaks(trades, breakEvenRange, dailyMaxLoss, timezone);
    return Math.round(leaks.reduce((s, l) => s + l.costDollars, 0));
  }, [trades, breakEvenRange, dailyMaxLoss, timezone]);
}

/** Whole days left in the trial, or null when not on a live trial. */
export function useTrialDaysLeft(): number | null {
  const { subscriptionStatus, trialEndsAt } = useStore();
  if (subscriptionStatus !== 'trialing' || !trialEndsAt) return null;
  const msLeft = new Date(trialEndsAt).getTime() - Date.now();
  if (msLeft <= 0) return null;
  return Math.max(1, Math.ceil(msLeft / 86_400_000));
}
